<div id="edit-container">

    <div id="header-edit">
        <h2>Editar</h2>
        <p>* Campos obligatorios</p>
    </div>

    <form [formGroup]="editForm" (submit)="submit()" fxLayout="column" fxLayoutAlign="center">

        <mat-form-field>
            <input matInput formControlName="email" type="email" class="form-control" placeholder="Correo electrónico *">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Tipo de documento</mat-label>
            <mat-select formControlName="documentType" (selectionChange)="documentTypeSelection($event.value)">
                <mat-option *ngFor="let document of documentTypes" [value]="document.name">
                    {{document.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <input matInput type="text" formControlName="document" placeholder="Cédula de ciudadanía *" (focusout)="verifyDocumentExists()" (focus)="disableSubmmit()" />
        </mat-form-field>
        <div *ngIf="documentUsed">
            <label class="text-danger">
                <i class="material-icons">cancel</i>
                ¡Ya existe un usuario con ese documento!
            </label>
        </div>

        <mat-form-field>
            <input matInput type="text" formControlName="fullName" placeholder="Nombre Completo" />
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="editForm.controls['fullName'].hasError('required')">
            ¡Necesitamos conocer tu nombre!
        </label>
        <mat-form-field>
            <input matInput type="text" formControlName="tugessiUserName" placeholder="Nombre corto de Usuario" />
        </mat-form-field>
        <label class="text-danger inputPrincipal" *ngIf="editForm.controls['tugessiUserName'].hasError('required')">
            ¡Necesitamos un nombre corto!
        </label>

        <mat-form-field class="custom-wrapper-example">
            <input matInput placeholder="Departamento" aria-label="Departamento" [formControl]="departamentosCtrl" [matAutocomplete]="autoDepartamento" (focusout)="focusOutDepartamento($event)">
            <mat-autocomplete #autoDepartamento="matAutocomplete" (optionSelected)="loadMunicipioByDepartamentoName($event.option.value)">
                <mat-option *ngFor="let departamento of filteredDepartamentos | async" [value]="departamento.departamento">
                    <span>{{departamento.departamento}}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="custom-wrapper-example">
            <input matInput placeholder="Ciudad" aria-label="Ciudad" [formControl]="citiesCtrl" [matAutocomplete]="autoCity" (focusout)="focusOutMunicipio($event)">
            <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="setMunicipio($event.option.value)">
                <mat-option *ngFor="let city of filteredCities | async" [value]="city.municipio">
                    <span>{{city.municipio}}</span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <input matInput type="text" formControlName="address" placeholder="Dirección" />
        </mat-form-field>

        <mat-form-field>
            <input matInput type="text" formControlName="mobilePhone" placeholder="Número de teléfono móvil" />
        </mat-form-field>


        <mat-checkbox *ngIf="!sponsorFieldFilled" id="isRefered" name="isRefered" formControlName="isRefered" [value]="isRefered" (change)="OnChekboxChange($event)">
            ¡Soy referido!
        </mat-checkbox>

        <label *ngIf="sponsorFieldFilled">
            <p>Ya eres referido!</p>
            <p (click)="viewSponsor()">¿Quién es mi patrocinador?</p>
        </label>

        <mat-form-field *ngIf="isRefered">
            <input matInput formControlName="emailSponsor" type="email" class="form-control" placeholder="Correo electrónico de la persona que te refirió" (focusout)="verifySponsor(emailReferente)" (focus)="checkSponsorDisabledSubmit()" [(ngModel)]="emailReferente">
        </mat-form-field>


        <mat-checkbox id="emailsOffert" formControlName="emailOffersCheck" name="isWantEmailsOffert">Quiero recibir vía e-mail ofertas y novedades de Tugessi.com
        </mat-checkbox>

        <div id="content-btn">
            <a id="btn-cancelar" href="home">Cancelar</a>

            <!-- <button mat-raised-button color="primary" [disabled]="editForm.invalid || !sponsorVerified&&isRefered" type="submit" -->
            <button mat-raised-button color="primary" [disabled]="editForm.invalid || !sponsorVerified&&isRefered || documentUsed || !isValidDocument || checkSponsorDisabled" type="submit" class="btn btn-primary btn-block font-weight-bold">Guardar</button>
        </div>
    </form>
    <app-loader></app-loader>
</div>